enum AccountType {
    PRIVATE = 'private',
    LEGAL = 'legal'
}

export default AccountType;
